export default __webpack_public_path__ + "static/media/comm-reconciliation-664x830-en.cc556d13.jpg";